/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { NachrichtDisplayModel as AceXFoundPortalCoreCaqModelsNachrichtDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/nachricht-display-model';
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';

@Injectable({
providedIn: 'root',
})

export class NachrichtService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiNachrichtPost
   */
  static readonly ApiNachrichtPostPath = '/api/Nachricht';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNachrichtPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNachrichtPost$Plain$Response(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: AceXFoundPortalCoreCaqModelsNachrichtDisplayModel
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, NachrichtService.ApiNachrichtPostPath, 'post');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiNachrichtPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNachrichtPost$Plain(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: AceXFoundPortalCoreCaqModelsNachrichtDisplayModel
  }): Observable<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel> {

    return this.apiNachrichtPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsNachrichtDisplayModel)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNachrichtPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNachrichtPost$Response(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: AceXFoundPortalCoreCaqModelsNachrichtDisplayModel
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, NachrichtService.ApiNachrichtPostPath, 'post');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiNachrichtPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNachrichtPost(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: AceXFoundPortalCoreCaqModelsNachrichtDisplayModel
  }): Observable<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel> {

    return this.apiNachrichtPost$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsNachrichtDisplayModel)
    );
  }

  /**
   * Path part for operation apiNachrichtAnswerPatch
   */
  static readonly ApiNachrichtAnswerPatchPath = '/api/Nachricht/Answer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNachrichtAnswerPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNachrichtAnswerPatch$Plain$Response(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: AceXFoundPortalCoreCaqModelsNachrichtDisplayModel
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, NachrichtService.ApiNachrichtAnswerPatchPath, 'patch');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiNachrichtAnswerPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNachrichtAnswerPatch$Plain(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: AceXFoundPortalCoreCaqModelsNachrichtDisplayModel
  }): Observable<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel> {

    return this.apiNachrichtAnswerPatch$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsNachrichtDisplayModel)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNachrichtAnswerPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNachrichtAnswerPatch$Response(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: AceXFoundPortalCoreCaqModelsNachrichtDisplayModel
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, NachrichtService.ApiNachrichtAnswerPatchPath, 'patch');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiNachrichtAnswerPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNachrichtAnswerPatch(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: AceXFoundPortalCoreCaqModelsNachrichtDisplayModel
  }): Observable<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel> {

    return this.apiNachrichtAnswerPatch$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsNachrichtDisplayModel)
    );
  }

  /**
   * Path part for operation apiNachrichtAnfrageIdGet
   */
  static readonly ApiNachrichtAnfrageIdGetPath = '/api/Nachricht/{anfrageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNachrichtAnfrageIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNachrichtAnfrageIdGet$Plain$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, NachrichtService.ApiNachrichtAnfrageIdGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiNachrichtAnfrageIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNachrichtAnfrageIdGet$Plain(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>> {

    return this.apiNachrichtAnfrageIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNachrichtAnfrageIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNachrichtAnfrageIdGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, NachrichtService.ApiNachrichtAnfrageIdGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiNachrichtAnfrageIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNachrichtAnfrageIdGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>> {

    return this.apiNachrichtAnfrageIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsNachrichtDisplayModel>)
    );
  }

}